export enum LoginTypeEnum {
    ADMIN = '1',
    VENDOR = '2',
    SUPERVISOR = '3',
    CONCILIATOR = '5',
}
